import React from 'react'
import Topheader from '../../components/Topheader'
import style from './styles.module.css'
export default function Rewardpoints() {
  return (
    <div>
        <Topheader colorbox="newfaq_header_color" title="Reward Points" />
                    <div className="main-container mb-5 px-3">
                        <div className={style.sub_text2_q}>
                            What are Reward Points?
                        </div>
                        <div className={style.sub_text3}>
                            Reward Points are the in-game currency you earn by playing, winning tournaments, and ranking on leaderboards. You can redeem them in the Baazi Store for exclusive offers and gift cards.
                        </div>
                        <div className={style.brd}></div>

                        <div className={style.sub_text2_q}>
                            Can Reward Points be converted to cash?
                        </div>
                        <div className={style.sub_text3}>
                            No. Reward Points can only be used to redeem rewards in the Baazi Store.
                        </div>
                        <div className={style.brd}></div>

                        <div className={style.sub_text2_q}>My Reward Points didn’t get added. What should I do?</div>
                        <div className={style.sub_text3}>Share your username and approximate time of play with Support — our team will check and fix it right away.</div>
                        <div className={style.brd}></div>

                        <div className={style.sub_text3}> For more detailed FAQs, visit the Reward Points section inside the app.</div>

                    </div>
    </div>
  )
}
